export enum ValidationErrorCodes {
  PromoCodeNotFound = 'promo-code-not-found',
  DateOfBirthDateRangeMinMax = 'date-of-birth-date-range-min-max',
  DateOfBirthDateRangeMin = 'date-of-birth-date-range-min',
}
